import { Badge, Box, Cover, Text, Tooltip } from '@optiaxiom/react';

import { CustomIcon } from '@frontend/components/ui';
import { Tool } from '@frontend/types';

import type { ToolsTableRow } from '../types';

const NameCell = ({
  toolRow,
  onRowSelection,
}: {
  toolRow: ToolsTableRow;
  onRowSelection: (tool: Tool | null) => void;
}) => {
  const rowData = toolRow;
  if (rowData.isRegistry) {
    return (
      <Box display="flex" alignItems="center" gap="8">
        <Text>{rowData.name}</Text>
        {!rowData.registry.organization_id && (
          <Tooltip content="Opal System tools">
            <Box>
              <CustomIcon name="optimizely" alt="Opal System Tools" height={12} />
            </Box>
          </Tooltip>
        )}
        <Badge variant="strong">{rowData.items.length}</Badge>
      </Box>
    );
  }

  return <ToolName tool={rowData.tool} onRowSelection={onRowSelection} />;
};

const ToolName = ({
  tool,
  onRowSelection,
}: {
  tool: Tool;
  onRowSelection: (tool: Tool | null) => void;
}) => {
  return (
    <Box>
      <Cover asChild>
        <Box onClick={() => onRowSelection(tool)} cursor="pointer" />
      </Cover>
      <Box display="flex" alignItems="center" gap="8">
        <Text>{tool.name}</Text>
        {tool.is_system_function && (
          <Tooltip content="System tool">
            <Box>
              <CustomIcon name="optimizely" alt="Opal System Tool" height={12} />
            </Box>
          </Tooltip>
        )}
        {tool.is_preview && <Badge intent="information">Preview</Badge>}
      </Box>
      <Text fontSize="sm" color="fg.tertiary" lineClamp="1">
        {tool.description}
      </Text>
    </Box>
  );
};

export default NameCell;
